import React from 'react';

import cx from 'classnames';

import styles from './StatusIndicator.module.scss';

export interface IStatusIndicator {
	type: string;
	status: string;
	className?: string;
}

const StatusIndicator = (props: IStatusIndicator) => {
	const { type = 'COMPLETED', status = 'Completed', className } = props;

	return (
		<div
			className={cx(
				styles.statusTag,
				{
					[styles.createdTag]: type === 'CREATED',
					[styles.cancelledTag]:
						type === 'CANCELLED' || type === 'FAILED' || type === 'ERRORED',
					[styles.expiredTag]: type === 'EXPIRED',
					[styles.completedTag]: type === 'COMPLETED' || type === 'PAID',
					[styles.queuedTag]: type === 'QUEUED' || type === 'PENDING',
				},
				className,
			)}
		>
			{status}
		</div>
	);
};

export default StatusIndicator;
